export const REACT_SOCKET_NOTIFICATION_LOG_NAMESPACE = 'tap:react-socket-notification';
export const ROOM_SEPARATOR_TOKEN = ':';
//# sourceMappingURL=config.js.map